import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class EstalyManagersService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/estaly_managers", { params: toSnakeCase(params) });
  }
}

export default new EstalyManagersService();
